import React, { useState } from 'react';
import CombinedEditableSection from '../../../../../../components/CombinedEditableSection.comp';
import {
  SlideWithImage,
  SlideImageContainer,
  ImagePlaceholder,
  SlideTitleContainer,
  SlidePoint,
  SlideTitle,
  PointText,
} from '../../../../../styles/LearnTab/slideBase.styles';
import { SlideTitleHeader } from '../common/SlideTitleHeader.comp';
import { renderTextWithId } from '../common/EditableSlideField.comp';
import { SlideImageLightboxModal } from '../common/SlideImageLightbox.comp';

export const SessionStartSlide = ({
  slide,
  highlightWord,
  isEditMode = false,
  slideEdits = {},
  showEnglishContent = false,
  onSaveEdit,
  onResetEdit,
  onCancelEdit,
  onImageClick,
}) => {
  const [internalLightbox, setInternalLightbox] = useState(null);

  const handleImgClick = (img) => {
    if (onImageClick) {
      onImageClick(img);
    } else {
      setInternalLightbox(img);
    }
  };

  const textRendererOptions = { slideEdits, showEnglishContent, highlightWord };

  return (
    <>
      <SlideWithImage>
        {slide?.Images && slide.Images.length > 0 && (
          <SlideImageContainer>
            <ImagePlaceholder>
              <img
                src={slide.Images[0]}
                alt="Slide image"
                onClick={() => handleImgClick(slide.Images[0])}
                style={{
                  width: '100%',
                  height: 'auto',
                  objectFit: 'contain',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  WebkitUserDrag: 'none',
                }}
              />
            </ImagePlaceholder>
          </SlideImageContainer>
        )}
        <SlideTitleContainer>
          <SlidePoint>
            {isEditMode ? (
              <CombinedEditableSection
                slide={slide}
                isEditMode={isEditMode}
                slideEdits={slideEdits}
                showEnglishContent={showEnglishContent}
                onSave={onSaveEdit}
                onReset={onResetEdit}
                onCancel={onCancelEdit}
                TitleComponent={SlideTitle}
                ContentComponent={PointText}
              />
            ) : (
              <>
                <SlideTitleHeader
                  slide={slide}
                  slideEdits={slideEdits}
                  showEnglishContent={showEnglishContent}
                  highlightWord={highlightWord}
                />
                {renderTextWithId('content_0', slide?.SlideContent, PointText, {}, textRendererOptions)}
              </>
            )}
          </SlidePoint>
        </SlideTitleContainer>
      </SlideWithImage>

      {!onImageClick && (
        <SlideImageLightboxModal
          image={internalLightbox}
          onClose={() => setInternalLightbox(null)}
        />
      )}
    </>
  );
};

export default SessionStartSlide;
